import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                 {/* {props.data ? props.data.title : "Carregando..."} */}
                  <span></span>
                </h1>
                <p >
                   {/* <span id="buttonConsulta" ><a href=""> {props.data ? props.data.paragraph : "Carregando..."}</a></span> */}
                </p>
                
                <a id="Consulta" href="https://luxvida.ailine.com.br/" className="btn btn-custom btn-lg page-scroll">FAÇA  SUA CONSULTA</a>{" "}

              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
